import { call, put, takeEvery } from 'redux-saga/effects'
import {
  // Job Categories
  jobCategoryListApiData,
  jobCategoryListApiSuccess,
  jobCategoryListApiFailed,
  addJobCategoryApiData,
  addJobCategoryApiSuccess,
  addJobCategoryApiFailed,
  updateJobCategoryApiData,
  updateJobCategoryApiSuccess,
  updateJobCategoryApiFailed,
  deleteJobCategoryApiData,
  deleteJobCategoryApiSuccess,
  deleteJobCategoryApiFailed,

  // Job Sub Categories
  jobSubCategoryListApiData,
  jobSubCategoryListApiSuccess,
  jobSubCategoryListApiFailed,
  addJobSubCategoryApiData,
  addJobSubCategoryApiSuccess,
  addJobSubCategoryApiFailed,
  updateJobSubCategoryApiData,
  updateJobSubCategoryApiSuccess,
  updateJobSubCategoryApiFailed,
  deleteJobSubCategoryApiData,
  deleteJobSubCategoryApiSuccess,
  deleteJobSubCategoryApiFailed,

  // Job Tags
  jobTagListApiData,
  jobTagListApiSuccess,
  jobTagListApiFailed,
  jobTagByIdApiData,
  jobTagByIdApiSuccess,
  jobTagByIdApiFailed,
  addJobTagApiData,
  addJobTagApiSuccess,
  addJobTagApiFailed,
  updateJobTagApiData,
  updateJobTagApiSuccess,
  updateJobTagApiFailed,
  deleteJobTagApiData,
  deleteJobTagApiSuccess,
  deleteJobTagApiFailed,
  activeInactiveJobTagListApiData,
  activeInactiveJobTagListApiSuccess,
  activeInactiveJobTagListApiFailed,
  jobProviderListApiData,
  jobProviderListApiSuccess,
  jobProviderListApiFailed,
  jobSeekerAppliedListApiData,
  jobSeekerAppliedListApiSuccess,
  jobSeekerAppliedListApiFailed,
  storeJobListApiData,
  storeJobListApiSuccess,
  storeJobListApiFailed,
  storeJobApplicationListApiData,
  storeJobApplicationListApiSuccess,
  storeJobApplicationListApiFailed,
  activeInactiveJobCategoryApiData,
  activeInactiveJobCategoryApiSuccess,
  activeInactiveJobCategoryApiFailed,
  activeInactiveJobSubCategoryApiData,
  activeInactiveJobSubCategoryApiSuccess,
  activeInactiveJobSubCategoryApiFailed,
  jobSeekerResumeListApiData,
  jobSeekerResumeListApiSuccess,
  jobSeekerResumeListApiFailed,
  jobSeekerResumeDetailsApiData,
  jobSeekerResumeDetailsApiSuccess,
  jobSeekerResumeDetailsApiFailed,
  jobDetailsApiData,
  jobDetailsApiSuccess,
  jobDetailsApiFailed,
} from './slice'

import { API } from '../../services'

/* ============================
      Job Category APIs
=============================== */
function* jobCategoryListApi({ payload }) {
  try {
    const response = yield call(API.jobManagement.getJobCategoryList, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(jobCategoryListApiSuccess({ payload: response?.data }))
    } else {
      yield put(jobCategoryListApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(jobCategoryListApiFailed({ message: error?.message }))
  }
}

function* addJobCategoryApi({ payload }) {
  try {
    const response = yield call(API.jobManagement.addJobCategoryList, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(addJobCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(addJobCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(addJobCategoryApiFailed({ message: error?.message }))
  }
}

function* updateJobCategoryApi({ payload }) {
  try {
    const response = yield call(API.jobManagement.updateJobCategoryList, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(updateJobCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateJobCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(updateJobCategoryApiFailed({ message: error?.message }))
  }
}

function* deleteJobCategoryApi({ payload }) {
  try {
    const response = yield call(API.jobManagement.deleteJobCategory, payload)
    if (response?.data && response?.status === 200) {
      yield put(deleteJobCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteJobCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(deleteJobCategoryApiFailed({ message: error?.message }))
  }
}

/* ============================
      Job Sub Category APIs
=============================== */
function* jobSubCategoryListApi({ payload }) {
  try {
    const response = yield call(API.jobManagement.getJobSubCategoryList, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(jobSubCategoryListApiSuccess({ payload: response?.data }))
    } else {
      yield put(jobSubCategoryListApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(jobSubCategoryListApiFailed({ message: error?.message }))
  }
}

function* addJobSubCategoryApi({ payload }) {
  try {
    const response = yield call(API.jobManagement.addJobSubCategoryList, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(addJobSubCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(addJobSubCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(addJobSubCategoryApiFailed({ message: error?.message }))
  }
}

function* updateJobSubCategoryApi({ payload }) {
  try {
    const response = yield call(API.jobManagement.updateJobSubCategoryList, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(updateJobSubCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateJobSubCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(updateJobSubCategoryApiFailed({ message: error?.message }))
  }
}

function* deleteJobSubCategoryApi({ payload }) {
  try {
    const response = yield call(API.jobManagement.deleteJobSubCategory, payload)
    if (response?.data && response?.status === 200) {
      yield put(deleteJobSubCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteJobSubCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(deleteJobSubCategoryApiFailed({ message: error?.message }))
  }
}

function* jobTagListApi({ payload }) {
  try {
    const response = yield call(API.jobManagement.getJobTagList, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(jobTagListApiSuccess({ payload: response?.data }))
    } else {
      yield put(jobTagListApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(jobTagListApiFailed({ message: error?.message }))
  }
}

function* jobTagByIdApi({ payload }) {
  try {
    const response = yield call(API.jobManagement.getJobTagById, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(jobTagByIdApiSuccess({ payload: response?.data }))
    } else {
      yield put(jobTagByIdApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(jobTagByIdApiFailed({ message: error?.message }))
  }
}

function* addJobTagApi({ payload }) {
  try {
    const response = yield call(API.jobManagement.addJobTag, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(addJobTagApiSuccess({ payload: response?.data }))
    } else {
      yield put(addJobTagApiFailed({ message: response?.message }))
      alert(response?.message || 'Something went wrong while fetching categories!') // ✅ ALERT
    }
  } catch (error) {
    yield put(addJobTagApiFailed({ message: error?.message }))
    alert(error?.message || 'Network error while fetching categories!') // ✅ ALERT
  }
}

function* updateJobTagApi({ payload }) {
  try {
    const response = yield call(API.jobManagement.updateJobTag, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(updateJobTagApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateJobTagApiFailed({ message: response?.message }))
      alert(response?.message || 'Something went wrong while fetching categories!') // ✅ ALERT
    }
  } catch (error) {
    yield put(updateJobTagApiFailed({ message: error?.message }))
    alert(error?.message || 'Network error while fetching categories!') // ✅ ALERT
  }
}

function* deleteJobTagApi({ payload }) {
  try {
    const response = yield call(API.jobManagement.deleteJobTag, payload)
    if (response?.data && response?.status === 200) {
      yield put(deleteJobTagApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteJobTagApiFailed({ message: response?.message }))
      alert(response?.message || 'Something went wrong while fetching categories!') // ✅ ALERT
    }
  } catch (error) {
    yield put(deleteJobTagApiFailed({ message: error?.message }))
    alert(error?.message || 'Network error while fetching categories!') // ✅ ALERT
  }
}

function* activeInactiveJobTagListApi({ payload }) {
  try {
    const response = yield call(API.jobManagement.activeInactiveJobTag, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(activeInactiveJobTagListApiSuccess({ payload: response?.data }))
    } else {
      yield put(activeInactiveJobTagListApiFailed({ message: response?.message }))
      alert(response?.message || 'Something went wrong while fetching categories!') // ✅ ALERT
    }
  } catch (error) {
    yield put(activeInactiveJobTagListApiFailed({ message: error?.message }))
    alert(error?.message || 'Network error while fetching categories!') // ✅ ALERT
  }
}

// ================= PROVIDER JOB LIST =================
function* jobProviderListApi({ payload }) {
  try {
    const response = yield call(API.jobManagement.getJobUserList, payload)

    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(jobProviderListApiSuccess({ payload: response.data }))
    } else {
      yield put(jobProviderListApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(jobProviderListApiFailed({ message: error?.message }))
  }
}

// ================= JOB SEEKER APPLIED =================
function* jobSeekerAppliedListApi({ payload }) {
  try {
    const response = yield call(API.jobManagement.getJobSeekerAppliedList, payload)

    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(jobSeekerAppliedListApiSuccess({ payload: response.data }))
    } else {
      yield put(jobSeekerAppliedListApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(jobSeekerAppliedListApiFailed({ message: error?.message }))
  }
}

// ================= STORE JOB LIST =================
function* storeJobListApi({ payload }) {
  try {
    const response = yield call(API.jobManagement.getStoreJobList, payload)

    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(storeJobListApiSuccess({ payload: response.data }))
    } else {
      yield put(storeJobListApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(storeJobListApiFailed({ message: error?.message }))
  }
}

// ================= STORE JOB APPLICATION LIST =================
function* storeJobApplicationListApi({ payload }) {
  try {
    const response = yield call(API.jobManagement.getStoreJobApplications, payload)

    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(storeJobApplicationListApiSuccess({ payload: response.data }))
    } else {
      yield put(storeJobApplicationListApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(storeJobApplicationListApiFailed({ message: error?.message }))
  }
}

function* activeInactiveJobCategoryApi({ payload }) {
  try {
    const response = yield call(API.jobManagement.activeInactiveJobCategory, payload)

    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(activeInactiveJobCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(activeInactiveJobCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(activeInactiveJobCategoryApiFailed({ message: error?.message }))
  }
}

function* activeInactiveJobSubCategoryApi({ payload }) {
  try {
    const response = yield call(API.jobManagement.activeInactiveJobSubCategory, payload)

    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(activeInactiveJobSubCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(activeInactiveJobSubCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(activeInactiveJobSubCategoryApiFailed({ message: error?.message }))
  }
}

function* jobSeekerResumeListApi({ payload }) {
  try {
    const response = yield call(API.jobManagement.getJobSeekerResumeList, payload)

    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(jobSeekerResumeListApiSuccess({ payload: response.data }))
    } else {
      yield put(jobSeekerResumeListApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(jobSeekerResumeListApiFailed({ message: error?.message }))
  }
}

function* jobSeekerResumeDetailsApi({ payload }) {
  try {
    const response = yield call(API.jobManagement.getJobSeekerResumeDetails, payload)

    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(jobSeekerResumeDetailsApiSuccess({ payload: response.data }))
    } else {
      yield put(jobSeekerResumeDetailsApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(jobSeekerResumeDetailsApiFailed({ message: error?.message }))
  }
}

function* jobDetailsApi({ payload }) {
  try {
    const response = yield call(API.jobManagement.getJobUserDetails, payload)

    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(jobDetailsApiSuccess({ payload: response.data }))
    } else {
      yield put(jobDetailsApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(jobDetailsApiFailed({ message: error?.message }))
  }
}

/* ============================
      Root Saga
=============================== */
function* manageJobSaga() {
  // Job Category
  yield takeEvery(jobCategoryListApiData, jobCategoryListApi)
  yield takeEvery(addJobCategoryApiData, addJobCategoryApi)
  yield takeEvery(updateJobCategoryApiData, updateJobCategoryApi)
  yield takeEvery(deleteJobCategoryApiData, deleteJobCategoryApi)

  // Job Sub Category
  yield takeEvery(jobSubCategoryListApiData, jobSubCategoryListApi)
  yield takeEvery(addJobSubCategoryApiData, addJobSubCategoryApi)
  yield takeEvery(updateJobSubCategoryApiData, updateJobSubCategoryApi)
  yield takeEvery(deleteJobSubCategoryApiData, deleteJobSubCategoryApi)

  // Job Tag
  yield takeEvery(jobTagListApiData, jobTagListApi)
  yield takeEvery(jobTagByIdApiData, jobTagByIdApi)
  yield takeEvery(addJobTagApiData, addJobTagApi)
  yield takeEvery(updateJobTagApiData, updateJobTagApi)
  yield takeEvery(deleteJobTagApiData, deleteJobTagApi)
  yield takeEvery(activeInactiveJobTagListApiData, activeInactiveJobTagListApi)

  yield takeEvery(jobProviderListApiData, jobProviderListApi)
  yield takeEvery(jobSeekerAppliedListApiData, jobSeekerAppliedListApi)
  yield takeEvery(storeJobListApiData, storeJobListApi)
  yield takeEvery(storeJobApplicationListApiData, storeJobApplicationListApi)

  yield takeEvery(activeInactiveJobCategoryApiData, activeInactiveJobCategoryApi)
  yield takeEvery(activeInactiveJobSubCategoryApiData, activeInactiveJobSubCategoryApi)
  yield takeEvery(jobSeekerResumeListApiData, jobSeekerResumeListApi)
  yield takeEvery(jobSeekerResumeDetailsApiData, jobSeekerResumeDetailsApi)

  yield takeEvery(jobDetailsApiData, jobDetailsApi)
}

export default manageJobSaga
